import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header--center" }
const _hoisted_3 = {
  key: 0,
  class: "header--center-step"
}
const _hoisted_4 = { class: "header--center-title" }

import { computed } from "vue";
import { RouteLocationRaw } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  props: {
    title: null,
    steps: null,
    backRouteTo: null,
    accountIcon: { type: Boolean },
    filterIcon: { type: Boolean }
  },
  emits: ["account", "filter"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'account'): void;
  (e: 'filter'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  title?: string;
  steps?: [number, number];
  backRouteTo?: RouteLocationRaw;
  accountIcon?: boolean;
  filterIcon?: boolean;
};





const stepsText = computed(() => {
  if (props.steps) {
    const [from, to] = props.steps;
    return `step ${from} of ${to}`;
  }

  return null
})



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.backRouteTo)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          class: "header--arrow-back",
          to: __props.backRouteTo
        }, null, 8, ["to"]))
      : _createCommentVNode("", true),
    (__props.accountIcon)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          class: "header--account",
          href: "#",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('account')), ["prevent"]))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_unref(stepsText))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(stepsText)), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.title), 1)
    ]),
    (__props.filterIcon)
      ? (_openBlock(), _createElementBlock("a", {
          key: 2,
          class: "header--filter",
          href: "#",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emit('filter')), ["prevent"]))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})